// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#workspace-photo-editor[data-v-42775294] {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #f2f2f2;\n    user-select: none;\n}\n", ""]);
// Exports
module.exports = exports;
